import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { TourProvider } from '@reactour/tour';
import "moment/locale/pt";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <PrimeReactProvider value={{ripple: true }}>
        <TourProvider steps={[]} position="center">
            <App />
        </TourProvider>
    </PrimeReactProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
